// modules/project-manager-ui-it.js
// Version italiana

import {
    saveCurrentProject,
    getAllProjects,
    loadProject,
    deleteProject,
    clearAllProjects,
    getStorageStats,
    exportProject,
    exportAllProjects
  } from './project-storage.js';
  import { i18n } from './traduction-it.js';
  
  export function createProjectManagerModal(onLoadProject) {
    const projectModal = document.createElement('div');
    projectModal.className = 'project-modal';
    projectModal.innerHTML = `
      <div class="project-content">
        <h3>${i18n.projectTitle}</h3>
        <div class="project-actions">
          <div class="action-group">
            <p>${i18n.projectIntro}</p>
          </div>
        </div>
        <br>
        <div class="project-actions">
          <div class="action-group">
            <h4>${i18n.projectSaveTitle}</h4>
            <div class="save-project-form">
              <input type="text" id="project-name-input" placeholder="${i18n.projectNamePH}">
              <button id="save-project-btn">${i18n.projectSaveBtn}</button>
            </div>
            <div id="save-message"></div>
          </div>
  
          <div class="action-group">
            <h4>${i18n.projectListTitle} (<span id="project-count">0</span>)</h4>
            <div class="storage-stats">
              <span id="storage-info">Calcolo in corso...</span>
            </div>
            <div class="projects-list-container">
              <div id="projects-list">
                <p>${i18n.projectLoading}</p>
              </div>
            </div>
          </div>
  
          <div class="action-group advanced-actions" style="display: none;">
            <h4>${i18n.advancedActions}</h4>
            <div class="advanced-buttons">
              <button id="clear-all-projects-btn" class="danger-btn">${i18n.btnClearAll}</button>
              <button id="export-all-projects-btn">${i18n.btnExportAll}</button>
            </div>
            <div id="export-progress" style="display: none;">
              <div class="progress-bar">
                <div class="progress-fill" id="export-progress-fill"></div>
              </div>
              <p id="export-progress-text">${i18n.exportPreparing}</p>
            </div>
          </div>
        </div>
  
        <button class="close-project-modal-btn">${i18n.projectClose}</button>
      </div>
    `;
    document.body.appendChild(projectModal);
  
    const closeButton        = projectModal.querySelector('.close-project-modal-btn');
    const saveButton         = projectModal.querySelector('#save-project-btn');
    const projectNameInput   = projectModal.querySelector('#project-name-input');
    const saveMessage        = projectModal.querySelector('#save-message');
    const projectsList       = projectModal.querySelector('#projects-list');
    const projectCount       = projectModal.querySelector('#project-count');
    const storageInfo        = projectModal.querySelector('#storage-info');
    const clearAllButton     = projectModal.querySelector('#clear-all-projects-btn');
    const exportAllButton    = projectModal.querySelector('#export-all-projects-btn');
    const exportProgress     = projectModal.querySelector('#export-progress');
    const exportProgressFill = projectModal.querySelector('#export-progress-fill');
    const exportProgressText = projectModal.querySelector('#export-progress-text');
  
    closeButton.addEventListener('click', () => {
      projectModal.style.display = 'none';
    });
  
    saveButton.addEventListener('click', async () => {
      const projectName = projectNameInput.value;
      const audioClips  = document.querySelectorAll('.sound-clips .clip');
  
      if (!projectName.trim()) { showMessage(i18n.noProjectName, 'error'); return; }
      if (audioClips.length === 0) { showMessage(i18n.noClipsToSave, 'error'); return; }
  
      saveButton.disabled = true;
      showMessage(i18n.projectSaving, 'info');
  
      try {
        const result = await saveCurrentProject(projectName, audioClips);
        if (result.success) {
          showMessage(result.message, 'success');
          projectNameInput.value = '';
          await refreshProjectsList();
        } else {
          showMessage(result.message, 'error');
        }
      } finally {
        saveButton.disabled = false;
      }
    });
  
    async function refreshProjectsList() {
      projectsList.innerHTML = `<p>${i18n.projectLoading}</p>`;
  
      try {
        const projects = await getAllProjects();
        const stats    = await getStorageStats();
  
        projectCount.textContent = projects.length;
        storageInfo.textContent  = `${stats.totalClips} clip • ~${stats.estimatedSizeMB} MB`;
  
        if (projects.length === 0) {
          projectsList.innerHTML = `<p class="empty-state">${i18n.projectNone}</p>`;
          return;
        }
  
        projectsList.innerHTML = '';
        projects.forEach(project => {
          projectsList.appendChild(createProjectElement(project));
        });
      } catch (error) {
        console.error('Errore durante il caricamento dei progetti:', error);
        projectsList.innerHTML = `<p class="error-state">${i18n.projectLoadError}</p>`;
      }
    }
  
    function showExportProgress(current, total) {
      exportProgress.style.display = 'block';
      const pct = Math.round((current / total) * 100);
      exportProgressFill.style.width = `${pct}%`;
      exportProgressText.textContent = i18n.exportInProgress(current, total, pct);
    }
  
    function hideExportProgress() {
      exportProgress.style.display   = 'none';
      exportProgressFill.style.width = '0%';
      exportProgressText.textContent = i18n.exportPreparing;
    }
  
    function createProjectElement(project) {
      const projectDate    = new Date(project.savedAt).toLocaleString('it-IT');
      const projectElement = document.createElement('div');
      projectElement.className = 'project-item';
      projectElement.innerHTML = `
        <div class="project-info">
          <span class="project-name">${escapeHtml(project.name)}</span>
          <span class="project-date">📅 ${projectDate}</span>
          <span class="project-clips-count">🎵 ${project.clips.length} clip</span>
        </div>
        <div class="project-actions">
          <button class="load-project-btn"   data-project-id="${project.id}" title="${i18n.projectLoadTitle}">${i18n.projectLoad}</button>
          <button class="export-single-project-btn" data-project-id="${project.id}" title="${i18n.projectZipTitle}">${i18n.projectZip}</button>
          <button class="delete-project-btn" data-project-id="${project.id}" title="${i18n.projectDeleteTitle}">${i18n.projectDelete}</button>
        </div>
      `;
  
      // Charger
      const loadBtn = projectElement.querySelector('.load-project-btn');
      loadBtn.addEventListener('click', async () => {
        if (!confirm(i18n.confirmLoad)) return;
        loadBtn.disabled = true;
        try {
          const projectData = await loadProject(project.id);
          onLoadProject(projectData);
          projectModal.style.display = 'none';
        } catch (error) {
          alert(i18n.errorLoad(error.message));
        } finally {
          loadBtn.disabled = false;
        }
      });
  
      // Exporter ZIP
      const exportBtn = projectElement.querySelector('.export-single-project-btn');
      exportBtn.addEventListener('click', async () => {
        exportBtn.disabled = true;
        const originalText = exportBtn.textContent;
        exportBtn.textContent = '⏳';
        try {
          showExportProgress(0, project.clips.length);
          await exportProject(project.id, (cur, tot) => showExportProgress(cur, tot));
          hideExportProgress();
          exportBtn.textContent = '✓';
          setTimeout(() => { exportBtn.textContent = originalText; }, 2000);
        } catch (error) {
          hideExportProgress();
          alert(i18n.errorExport(error.message));
          exportBtn.textContent = originalText;
        } finally {
          exportBtn.disabled = false;
        }
      });
  
      // Supprimer
      const deleteBtn = projectElement.querySelector('.delete-project-btn');
      deleteBtn.addEventListener('click', async () => {
        if (!confirm(i18n.confirmDelete(project.name))) return;
        deleteBtn.disabled = true;
        try {
          await deleteProject(project.id);
          await refreshProjectsList();
        } catch (error) {
          alert(i18n.errorDelete(error.message));
        } finally {
          deleteBtn.disabled = false;
        }
      });
  
      return projectElement;
    }
  
    clearAllButton.addEventListener('click', async () => {
      if (!confirm(i18n.confirmClearAll1)) return;
      if (!confirm(i18n.confirmClearAll2)) return;
      clearAllButton.disabled = true;
      try {
        await clearAllProjects();
        await refreshProjectsList();
        showMessage(i18n.successClear, 'success');
      } catch (error) {
        alert(i18n.errorClear(error.message));
      } finally {
        clearAllButton.disabled = false;
      }
    });
  
    exportAllButton.addEventListener('click', async () => {
      const projects = await getAllProjects();
      if (projects.length === 0) { alert(i18n.noProjectsToExport); return; }
  
      const totalFiles = projects.reduce((sum, p) => sum + p.clips.length, 0);
      if (!confirm(i18n.confirmExportAll(totalFiles, projects.length))) return;
  
      exportAllButton.disabled = true;
      const originalText = exportAllButton.textContent;
      exportAllButton.textContent = '⏳ Esportazione in corso...';
  
      try {
        showExportProgress(0, totalFiles);
        await exportAllProjects((cur, tot) => showExportProgress(cur, tot));
        hideExportProgress();
        exportAllButton.textContent = i18n.exportSuccess;
        setTimeout(() => { exportAllButton.textContent = originalText; }, 3000);
      } catch (error) {
        hideExportProgress();
        alert(i18n.errorExport(error.message));
        exportAllButton.textContent = originalText;
      } finally {
        exportAllButton.disabled = false;
      }
    });
  
    function showMessage(message, type) {
      saveMessage.textContent = message;
      saveMessage.className   = `${type}-message`;
      setTimeout(() => { saveMessage.textContent = ''; saveMessage.className = ''; }, 5000);
    }
  
    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  
    return {
      modal:   projectModal,
      show:    async () => { projectModal.style.display = 'flex'; await refreshProjectsList(); },
      hide:    () => { projectModal.style.display = 'none'; },
      refresh: refreshProjectsList
    };
  }
  
  export function createProjectManagerButton(onClick) {
    const button = document.querySelector('.project-manager-toggle');
    if (button) button.addEventListener('click', onClick);
    return button;
  }